import { render } from "./ListeNotificationPage.vue?vue&type=template&id=5ca444cf&ts=true"
import script from "./ListeNotificationPage.vue?vue&type=script&lang=ts"
export * from "./ListeNotificationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__